
angular.module('tf.directives')

    .directive('gaugeChart', function() {
    return {
        restrict: 'E',
        //template: '<div class="tf-gauge"></div>',
        templateUrl: "js/components/charts/gauge/gauge.html",
        replace: true,
        scope:{
            data:"=",
            total : "=",
            label : "=?"

        },
        link : function(scope,element,attr){
            scope.data = scope.data || [];
            var chart = c3.generate({
                bindto : element.find('.tf-gauge-chart')[0],
                data: {
                    type: 'gauge',
                    columns : [scope.data]
                },
                gauge: {
                    max: scope.total,
                    label: {
                        //show: false,
                        format: function (value, ratio) {
                            scope.value = value;
                            //scope.value = d3.format('%')(ratio);
                            return ;
                            //return scope.label || d3.format('%')(ratio);
                        }
                    }

                },
                tooltip : {
                    show : false
                },
                color: {
                    pattern: ['#60B044', '#F6C600', '#F97600', '#FF0000'], // the three color levels for the percentage values.
                    threshold: {
                        values: [scope.total*0.3, scope.total*0.6, scope.total*0.9, scope.total]
                    }
                },
                size: {
                    height: 150
                }
            });

            //var i = 0;
            //var c = setInterval(function(){
            //    i++;
            //    chart.load({
            //        columns : [['data', i]]
            //    });
            //    if(i == max){clearInterval(c);}
            //
            //},500);

            scope.$watchGroup(['data','total'], function(data){
                chart.internal.config.gauge_max = data[1];
                if(data[1]) {
                    chart.internal.config.color_threshold.values[0] = data[1] * 0.3;
                    chart.internal.config.color_threshold.values[1] = data[1] * 0.6;
                    chart.internal.config.color_threshold.values[2] = data[1] * 0.9;
                    chart.internal.config.color_threshold.values[3] = data[1];

                }
                chart.load({
                    unload:true,
                    columns: [data[0]]
                });

            });

        }
    };

});